import { motion } from "framer-motion";
import { useState, useEffect } from "react";
import logo from "@/assets/logo.jpg";

export function LoadingScreen() {
  const [progress, setProgress] = useState(0);
  const duration = 3000; // 3 seconds

  useEffect(() => {
    const startTime = Date.now();
    const interval = setInterval(() => {
      const elapsed = Date.now() - startTime;
      const newProgress = Math.min(Math.floor((elapsed / duration) * 100), 100);
      setProgress(newProgress);
      
      if (newProgress >= 100) {
        clearInterval(interval);
      }
    }, 50);

    return () => clearInterval(interval);
  }, []);

  return (
    <motion.div
      className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-gradient-primary"
      initial={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5, ease: "easeInOut" }}
    >
      {/* Logo */}
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        className="relative"
      >
        <motion.img
          src={logo}
          alt="Nurture Skin Studio"
          className="w-24 h-24 rounded-lg shadow-glow object-contain"
          animate={{ 
            boxShadow: [
              "0 0 20px hsl(350 60% 75% / 0.3)",
              "0 0 40px hsl(350 60% 75% / 0.5)",
              "0 0 20px hsl(350 60% 75% / 0.3)",
            ]
          }}
          transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
        />
        
        {/* Spinning ring */}
        <motion.div
          className="absolute inset-0 rounded-lg border-2 border-transparent border-t-primary"
          animate={{ rotate: 360 }}
          transition={{ duration: 1.5, repeat: Infinity, ease: "linear" }}
          style={{ margin: "-4px", width: "calc(100% + 8px)", height: "calc(100% + 8px)" }}
        />
      </motion.div>

      {/* Brand name */}
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3, duration: 0.5 }}
        className="mt-8 text-center"
      >
        <h1 className="font-serif text-2xl text-foreground mb-2">Nurture Skin Studio</h1>
        <p className="text-sm text-muted-foreground tracking-widest uppercase">Where Luxury Meets Radiance</p>
      </motion.div>

      {/* Progress bar and percentage */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.5 }}
        className="mt-8 w-48 flex flex-col items-center gap-3"
      >
        {/* Progress bar */}
        <div className="w-full h-1 bg-muted rounded-full overflow-hidden">
          <motion.div
            className="h-full bg-primary rounded-full"
            initial={{ width: "0%" }}
            animate={{ width: `${progress}%` }}
            transition={{ duration: 0.1, ease: "linear" }}
          />
        </div>
        
        {/* Percentage text */}
        <motion.span
          className="text-lg font-medium text-primary tabular-nums"
          key={progress}
        >
          {progress}%
        </motion.span>
      </motion.div>
    </motion.div>
  );
}
